// What pages call to read leads offline-first: the local mirror is authoritative
// for display; syncNow refreshes it from the server when there's signal.
import { getAllRecords } from './db';
import { syncNow } from './sync';

export async function getLocalLeads() {
  const leads = await getAllRecords('leads');
  // Newest first, matching the online list's default order.
  return leads.sort((a, b) => String(b.createdAt || '').localeCompare(String(a.createdAt || '')));
}

export { syncNow };
